<template>
    <v-container max-width="100%" style="margin-top: 3%; padding: 0;">

        <template>
            <v-row justify="center">
                <v-dialog v-model="confirmDialog" persistent max-width="500" style="border-radius: 10px">
                    <v-card>
                        <v-card-title class="headline">
                            <span class="mensagemTxt">{{ $t('system.alert') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <span class="mensagemTxt">{{ this.mensagemdialog }}</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">
                                {{ this.messageDismissButton }}
                            </v-btn>
                            <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text"
                                @click="clickHandler">
                                {{ this.messageConfirmButton }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>

        <v-container style="margin-left: 0px; margin-right: 0px; padding-left: 0px; padding-right: 0px;">
            <v-row>
                <v-col cols="12" sm="3">
                    <v-card class="mx-auto" tile width="100%">
                        <v-navigation-drawer permanent width="100%">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <span class="headline" style="color: #4a4a4a">{{ $t('themes.title')
                                                }}</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                            <v-divider></v-divider>
                            <v-list nav dense>
                                <v-list-item-group v-model="selectedSection" color="primary">
                                    <v-list-item v-for="(section, i) in sections" :key="i">
                                        <v-list-item-icon>
                                            <v-icon v-text="section.icon"></v-icon>
                                        </v-list-item-icon>

                                        <v-list-item-content>
                                            <v-list-item-title v-text="section.text"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-navigation-drawer>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="9">
                    <v-card>
                        <v-card-title>
                            <span class="headline" style="color: #4a4a4a">{{ title }}</span>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" dark small class="mb-2 mr-2" fab @click="showHelpDialog">
                                <v-icon>mdi-help</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <template v-if="selectedSection === 0">
                                <merus-data-table 
                                    :headers="headers" 
                                    :items="temas" 
                                    :loading="loadingtable" 
                                    :loading-text="$t('themes.loading')"
                                    sort-by="padrao" 
                                    dense 
                                    locale="pt"
                                    cod-tabela="APARENCIA"
                                    append-actions
                                    actions-i18n-key="themes.headers.main.active"
                                    @update:headers="headers = $event"
                                    @update:displayedItems="displayedItemsForExport = $event">
                                    <template v-slot:toolbar>
                                        <CadastroToolbar
                                            :title="$t('themes.title')"
                                            :token="token"
                                            :items="displayedItemsForExport !== null ? displayedItemsForExport : temas"
                                            hide-search
                                        >
                                            <template v-slot:add v-if="canInsert">
                                                <v-dialog v-model="dialog" fullscreen max-width="100%">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                                            <v-icon>mdi-plus</v-icon>
                                                        </v-btn>
                                                    </template>

                                                <v-card>
                                                    <v-toolbar dark color="primary">
                                                        <v-btn icon dark @click="close">
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-toolbar-items>
                                                            <v-btn dark text @click="save">{{ $t('button.save')
                                                                }}</v-btn>
                                                        </v-toolbar-items>
                                                    </v-toolbar>
                                                    <template width="100%">

                                                        <v-container class="center" width="80%" id="boxContent">
                                                            <v-card>
                                                                <v-card-title max-width="100%">
                                                                    <span class="text-h4" style="color: #4a4a4a">{{
                                                                        $tc('themes.self', 1) }}</span>
                                                                </v-card-title>

                                                                <v-list>
                                                                    <v-list-item class="text-h5" title="main">{{
                                                                        $t('themes.informations') }}</v-list-item>

                                                                    <v-divider></v-divider>

                                                                    <v-list-item class="list-item">
                                                                        <v-row justify="space-around">
                                                                            <v-col align-self="center" cols="5">
                                                                                <v-list-item-title class="text-h6">{{
                                                                                    $t('themes.description')
                                                                                    }}:</v-list-item-title>
                                                                                <v-list-item-subtitle>{{
                                                                                    $t('themes.descriptionSubtitle')
                                                                                    }}</v-list-item-subtitle>
                                                                            </v-col>
                                                                            <v-col cols="7">
                                                                                <v-text-field
                                                                                    :label="$t('system.labels.description')"
                                                                                    v-model="editedItem.descricao"></v-text-field>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-list-item>

                                                                    <v-divider></v-divider>

                                                                    <v-list-item class="text-h5" title="main">{{
                                                                        $t('themes.mainPage') }}:</v-list-item>

                                                                    <v-list-item class="list-item">
                                                                        <v-row justify="space-around">
                                                                            <v-col align-self="center" cols="10">
                                                                                <v-list-item-title class="text-h6">{{
                                                                                    $t('themes.backgroundColor')
                                                                                    }}:</v-list-item-title>
                                                                                <v-list-item-subtitle>{{
                                                                                    $t('themes.backgroundColorSubtitle')
                                                                                    }}</v-list-item-subtitle>
                                                                            </v-col>
                                                                            <v-col cols="2">
                                                                                <v-menu offset-y
                                                                                    :close-on-content-click="false">
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn
                                                                                            :color="editedTheme.background"
                                                                                            fab x-large
                                                                                            v-on="on"></v-btn>
                                                                                    </template>
                                                                                    <v-color-picker
                                                                                        v-model="editedTheme.background"
                                                                                        class="mx-auto"
                                                                                        mode="hexa"></v-color-picker>
                                                                                </v-menu>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-list-item>

                                                                    <v-list-item class="list-item">
                                                                        <v-row justify="space-around">
                                                                            <v-col align-self="center" cols="10">
                                                                                <v-list-item-title class="text-h6">{{
                                                                                    $t('themes.buttonColor')
                                                                                    }}:</v-list-item-title>
                                                                                <v-list-item-subtitle>{{
                                                                                    $t('themes.buttonColorSubtitle')
                                                                                    }}</v-list-item-subtitle>
                                                                            </v-col>
                                                                            <v-col cols="2">
                                                                                <v-menu offset-y
                                                                                    :close-on-content-click="false">
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn
                                                                                            :color="editedTheme.button"
                                                                                            fab x-large
                                                                                            v-on="on"></v-btn>
                                                                                    </template>
                                                                                    <v-color-picker
                                                                                        v-model="editedTheme.button"
                                                                                        class="mx-auto"
                                                                                        mode="hexa"></v-color-picker>
                                                                                </v-menu>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-list-item>

                                                                    <v-list-item class="list-item">
                                                                        <v-row justify="space-around">
                                                                            <v-col align-self="center" cols="10">
                                                                                <v-list-item-title class="text-h6">{{
                                                                                    $t('themes.buttonFontColor')
                                                                                    }}:</v-list-item-title>
                                                                                <v-list-item-subtitle>{{
                                                                                    $t('themes.buttonFontColorSubtitle')
                                                                                    }}</v-list-item-subtitle>
                                                                            </v-col>
                                                                            <v-col cols="2">
                                                                                <v-checkbox
                                                                                    v-model="editedTheme.buttonText"
                                                                                    value="white--text"
                                                                                    :label="$t('themes.labelLightTheme')"></v-checkbox>
                                                                                <v-checkbox
                                                                                    v-model="editedTheme.buttonText"
                                                                                    value="black--text"
                                                                                    :label="$t('themes.labelDarkTheme')"></v-checkbox>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-list-item>

                                                                    <v-divider></v-divider>

                                                                    <v-list-item class="text-h5" title="header">{{
                                                                        $t('themes.pageHeader') }}:</v-list-item>

                                                                    <v-list-item class="list-item">
                                                                        <v-row justify="space-around">
                                                                            <v-col align-self="center" cols="10">
                                                                                <v-list-item-title class="text-h6">{{
                                                                                    $t('themes.pageHeaderColor')
                                                                                    }}:</v-list-item-title>
                                                                                <v-list-item-subtitle>{{
                                                                                    $t('themes.pageHeaderColorSubtitle')
                                                                                    }}</v-list-item-subtitle>
                                                                            </v-col>
                                                                            <v-col cols="2">
                                                                                <v-menu offset-y
                                                                                    :close-on-content-click="false">
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn
                                                                                            :color="editedTheme.header"
                                                                                            fab x-large
                                                                                            v-on="on"></v-btn>
                                                                                    </template>
                                                                                    <v-color-picker
                                                                                        v-model="editedTheme.header"
                                                                                        class="mx-auto"
                                                                                        mode="hexa"></v-color-picker>
                                                                                </v-menu>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-list-item>

                                                                    <v-list-item class="list-item">
                                                                        <v-row justify="space-around">
                                                                            <v-col align-self="center" cols="10">
                                                                                <v-list-item-title class="text-h6">{{
                                                                                    $t('themes.menuColor')
                                                                                    }}:</v-list-item-title>
                                                                                <v-list-item-subtitle>{{
                                                                                    $t('themes.menuColorSubtitle')
                                                                                    }}</v-list-item-subtitle>
                                                                            </v-col>
                                                                            <v-col cols="2">
                                                                                <v-menu offset-y
                                                                                    :close-on-content-click="false">
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn
                                                                                            :color="editedTheme.menuBackground"
                                                                                            fab x-large
                                                                                            v-on="on"></v-btn>
                                                                                    </template>
                                                                                    <v-color-picker
                                                                                        v-model="editedTheme.menuBackground"
                                                                                        class="mx-auto"
                                                                                        mode="hexa"></v-color-picker>
                                                                                </v-menu>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-list-item>

                                                                    <v-list-item class="list-item">
                                                                        <v-row justify="space-around">
                                                                            <v-col align-self="center" cols="10">
                                                                                <v-list-item-title class="text-h6">{{
                                                                                    $t('themes.menuTextColor')
                                                                                    }}:</v-list-item-title>
                                                                                <v-list-item-subtitle>{{
                                                                                    $t('themes.menuTextColorSubtitle')
                                                                                    }}</v-list-item-subtitle>
                                                                            </v-col>
                                                                            <v-col cols="2">
                                                                                <v-menu offset-y
                                                                                    :close-on-content-click="false">
                                                                                    <template v-slot:activator="{ on }">
                                                                                        <v-btn
                                                                                            :color="editedTheme.menuText"
                                                                                            fab x-large
                                                                                            v-on="on"></v-btn>
                                                                                    </template>
                                                                                    <v-color-picker
                                                                                        v-model="editedTheme.menuText"
                                                                                        class="mx-auto"
                                                                                        mode="hexa"></v-color-picker>
                                                                                </v-menu>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-card>
                                                        </v-container>
                                                    </template>
                                                </v-card>
                                            </v-dialog>
                                            </template>
                                        </CadastroToolbar>
                                    </template>

                                    <template v-slot:item.descricao="{ item }">
                                        {{ translateThemeName(item) }}
                                    </template>

                                    <template v-slot:item.padrao="{ item }">
                                        <p>
                                            {{ padraoIcon(item) }}
                                        </p>
                                    </template>

                                    <template v-slot:item.ativo="{ item }">
                                        <v-switch v-model="item.ativo" :disabled="item.ativo == 1"
                                            @change="activateTheme(item)"></v-switch>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small class="mr-2" color="green" @click="editItem(item)"
                                            :disabled="!item.can_edit && !user.is_superadmin || item.padrao == 1 || !canEdit">
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon :disabled="item.ativo == 1 || item.padrao == 1 || !user.is_superadmin || !canDelete"
                                            small class="mr-2" color="red" @click="deleteItemTheme(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                </merus-data-table>
                            </template>
                            <template v-if="selectedSection === 1">
                                <v-card>
                                    <v-container fluid>
                                        <v-item-group v-model="selectedLogo">
                                            <v-row>
                                                <v-col v-for="(item, i) in logos" :key="i" cols="6" md="6"
                                                    align-self="center">
                                                    <v-item>
                                                        <v-img :src="imgSrc + item.src" width="400" height="150" contain
                                                            class="grey darken-4">
                                                            <v-btn icon dark
                                                                style="background-color: rgba(255, 255, 255, 0.3); margin: 5px;"
                                                                @click="activateLogo(item)"
                                                                v-on:click="$emit('change', $event.target.checked)">
                                                                <v-icon>
                                                                    {{ item.ativo ? 'mdi-checkbox-marked' :
                                                                    'mdi-checkbox-blank-outline' }}
                                                                </v-icon>
                                                            </v-btn>
                                                            <v-btn icon dark @click="deleteItemLogo(item)"
                                                                style="background-color: rgba(255, 255, 255, 0.3); margin: 5px;"
                                                                :disabled="item.ativo ? true : false">
                                                                <v-icon>
                                                                    mdi-trash-can-outline
                                                                </v-icon>
                                                            </v-btn>
                                                        </v-img>
                                                    </v-item>
                                                </v-col>
                                            </v-row>
                                            <v-spacer></v-spacer>
                                        </v-item-group>
                                        <v-item-group>
                                            <v-row>
                                                <v-col cols="10">
                                                    <v-file-input accept="image/*" v-model="image" label="File input"
                                                        prepend-icon="mdi-camera" filled variant="solo-filled"
                                                        @change="onFileChange"></v-file-input>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-btn color="primary" dark small class="mb-2 mr-2" fab
                                                        @click="uploadFile">
                                                        <v-icon>mdi-upload-circle</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-item-group>
                                        <v-img class="mx-2" :src="imageUrl" :height="imageUrl ? 300 : 0" max-width="300"
                                            contain></v-img>
                                    </v-container>
                                </v-card>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import EventBus from "@/utils/eventBus";
import { ApiBaseUrl } from "@/constants";
import apiController from "@/utils/apiController";
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import MerusDataTable from './Tables/MerusDataTable.vue';
import translateDbField from "@/utils/translateDbField";

    export default {
        components: {
            CadastroToolbar,
            MerusDataTable,
        },
        data: () => ({
    headers: [],
            selectedSection: 0,
            helpDialog: false,
            user: null,
            token: null,
            mensagemCor:null,
            dialog: false,
            loadingtable: true,
            confirmDialog: false,
            mensagemdialog: "",
            showConfirmButton: true,
            editedIndex: -1,
            deleteIndex: null,
            editedItem: {
                id_tema: null,
                tema: null,
                descricao: null,
                ativo: null,
            },
            deletedItemTema: {
                id_tema: null,
                descricao: null,
                ativo: null,
            },
            deletedItemLogo: {
                id_logo: null,
                src: null,
                name: null,
            },
            defaultItem: {
                id_tema: null,
                descricao: null,
                ativo: null,
                padrao: null,
            },
            temas: [],
            displayedItemsForExport: null,
            logos: [],
            selectedLogo: null,
            open: ['mainPage', 'header'],
            mode: [
                'hexa'
            ],
            defaultTheme: {
                background: null,
                button: null,
                buttonText: "white--text",
                header: null,
                menuBackground: null,
                menuText: null,
            },
            editedTheme:{
                background: null,
                button: null,
                buttonText: "white--text",
                header: null,
                menuBackground: null,
                menuText: null,
            },
            offsetTop: 0,
            image: null,
            imageUrl: null,
            recursos: [],
            canInsert: false,
            canEdit: false,
            canDelete: false,
        }),
        computed: {
            title() {
                return this.sections[this.selectedSection].text;
            },
            formTitle() {
                return this.editedIndex === -1 ? this.$t('themes.registerTheme') : this.$t('themes.editTheme');
            },
            imgSrc(){
                return `${ApiBaseUrl}/`
            },
            sections() {
                return [
                    { icon: "mdi-palette", text: this.$t('themes.systemAppearanceSection') },
                    { icon: "mdi-image", text: this.$t('themes.systemLogoSection') }]
            },
            messageConfirmButton() {
                return this.$t('button.confirm');
            },
            messageDismissButton() {
                return this.$t('button.dismiss');
            },
            headersWithProperties() {
                return this.headers.map(header => ({
                    ...header,
                    filtrable: true,
                    sortable: true
                }));
            }
        },
        watch: {
            '$i18n.locale'() {
                this.initialize();
            }
        },
        created() {
            const tema = this.$vuetify.theme.themes.light;

        this.editedTheme = Object.assign({}, tema);
        this.defaultTheme = Object.assign({}, tema);

            this.user = JSON.parse(sessionStorage.getItem("user"));
            this.token = sessionStorage.getItem("api");
            this.populaRecursos();
        },
        methods: {

            populaRecursos() {
                if (this.user.is_superadmin === 1) {
                    apiController.request(apiController.endpoints.getallRecursos, {
                        onSuccess: (response) => {
                            this.recursos = response.data;
                            this.canEdit = true;
                            this.canInsert = true;
                            this.canDelete = true;
                            this.initialize();
                            this.populaLogos();
                        },
                    });
                } else {
                    apiController.request(apiController.endpoints.getRecursosusuario, {
                        params: { id: this.user.id_usuario },
                        onSuccess: (response) => {
                            this.recursos = response.data;
                            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatetema");
                            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/inserttema");
                            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletetema");
                            this.initialize();
                            this.populaLogos();
                        },
                    });
                }
            },
            showHelpDialog() {
                this.helpDialog = true;
            },
            closeHelpDialog() {
                this.helpDialog = false;
            },
            initialize() {
                apiController.request(apiController.endpoints.temaAll, {
                onSuccess: (response) => {
                    this.temas = response.data;
                    this.loadingtable = false;
                },
            });
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.deletedItemTema = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.editedTheme = Object.assign({}, this.defaultTheme);
            });
        },
        save() {
            const tema = JSON.stringify(this.editedTheme);

            this.editedItem.tema = tema

            if (this.editedIndex !== -1) {
                this.operacao = 0;
                apiController.request(apiController.endpoints.temaUpdate, {
                    data: this.editedItem,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                    },
                });
            } else {
                this.operacao = 1;

                apiController.request(apiController.endpoints.tema, {
                    data: this.editedItem,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                    },
                });
            }
        },
        populaLogos() {
            apiController.request(apiController.endpoints.temaLogoAll, {
                onSuccess: (response) => {
                    const resposta = response.data;
                    this.logos = resposta;
                },
            });
        },
        editItem(item) {
            this.editedIndex = this.temas.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
            const editedTema = JSON.parse(this.editedItem.tema);

            this.editedTheme = Object.assign({}, editedTema);

        },
        deleteItemTheme(item) {
            this.deletedItemTema = Object.assign({}, item);
            const translatedName = this.translateThemeName(item);
            this.mensagemdialog = this.$t('themes.confirmDeleteThemeMessage', { theme: translatedName });
            this.mensagemCor = "#d60000";
            this.showConfirmButton = true;
            this.messageDismissButton = this.$t('button.dismiss');
            this.messageConfirmButton = this.$t('button.confirm');
            this.confirmDialog = true;
            this.deleteIndex = 1;
        },
        deleteItemLogo(item) {
            this.deletedItemLogo = Object.assign({}, item);
            this.mensagemdialog = this.$t('themes.confirmDeleteLogoMessage', { logo: item.name });
            this.mensagemCor = "#d60000";
            this.showConfirmButton = true;
            this.messageDismissButton = this.$t('button.dismiss');
            this.messageConfirmButton = this.$t('button.confirm');
            this.confirmDialog = true;
            this.deleteIndex = 0;
        },
        activateThemeConfirmation(item) {
            const translatedName = this.translateThemeName(item);
            this.mensagemdialog = this.$t('themes.confirmApplyTheme', { theme: translatedName });
            this.mensagemCor = "#070707FF";
            this.showConfirmButton = true;
            this.messageDismissButton = this.$t('button.dismiss');
            this.messageConfirmButton = this.$t('button.confirm');
            this.confirmDialog = true;
        },
        clickHandler() {
            if (this.deleteIndex === 1) {
                this.deleteFromDatabaseTema();
            } else {
                if (this.deleteIndex === 0) {
                    this.deleteFromDatabaseLogo();
                } else {
                    location.reload();
                }
            }
        },
        deleteFromDatabaseTema() {
            this.operacao = 2;
            this.confirmDialog = false;

            apiController.request(apiController.endpoints.temaDelete, {
                    data: this.deletedItemTema,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                    },
                });
        },
        deleteFromDatabaseLogo() {
            this.confirmDialog = false;

            apiController.request(apiController.endpoints.temaDeleteLogo, {
                    data: this.deletedItemLogo,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                    },
                });
            },
            updateTable(status) {
                if (status) {
                    if (this.operacao == 0) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('themes.updateTable.error.insert'), tipo: 'error' });
                    } else {
                    if (this.operacao == 1) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('themes.updateTable.error.update'), tipo: 'error' });
                    } else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('themes.updateTable.error.delete'), tipo: 'error' });
                    }
                    }
                } else {
                    if (this.operacao == 0) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('themes.updateTable.success.insert'), tipo: 'success' });
                    } else {
                    if (this.operacao == 1) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('themes.updateTable.success.update'), tipo: 'success' });
                    } else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('themes.updateTable.success.delete'), tipo: 'success' });
                    }
                    }
                }
                this.close();
                this.initialize();
                this.populaLogos();
            },
            reloadPage(){
                location.reload();
            },
            activateTheme(item){
                const temaSelecionado = Object.assign({}, item);

            this.operacao = 1;
            apiController.request(apiController.endpoints.temaActivaTe, {
                    data: temaSelecionado,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                        window.location.reload();
                    },
                });
            },
            activateLogo(item){
                const logoSelecionado = Object.assign({}, item);

                if (logoSelecionado.ativo == 1) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('themes.logoAlreadyActive'), tipo: 'error' });
                    return;
                }

            this.operacao = 1;
            apiController.request(apiController.endpoints.activaTelogo, {
                    data: logoSelecionado,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);

                        sessionStorage.setItem("logo", logoSelecionado.src);
                        this.$root.$emit("logoChanged", logoSelecionado.src);
                    },
                });
            },
            createImage(file) {
                const reader = new FileReader();

            reader.onload = e => {
                this.imageUrl = e.target.result;
            }
            reader.readAsDataURL(file);
        },
        onFileChange(file) {
            if (!file) {
                return;
            }
            this.createImage(file);
        },
        createLogo(path) {
            const body = { src: path.slice(7), name: path.slice(21) }

            apiController.request(apiController.endpoints.temaLogo, {
                    data: body,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                        this.populaLogos();
                        this.image = null;
                        this.imageUrl = null;
                    },
                });
            },
            uploadFile(){
                const img = {file: String(this.imageUrl), filename: this.image.name.slice(0,-4), folder: "logos"};

            apiController.request(apiController.endpoints.uploadImg, {
                    data: img,
                    onSuccess: (response) => {
                        this.createLogo(response.data.path);
                    },
                });
            },
            toggleClass(){
                const miniature = document.querySelector("#miniature");
                const boxContent = document.querySelector("#boxContent");

            const miniatureClasses = miniature.classList;
            const boxContentClasses = boxContent.classList;

            miniatureClasses.toggle("fixed");
            miniatureClasses.toggle("free");

            boxContentClasses.toggle("center");
            boxContentClasses.toggle("right");

        },
        cancel() {
            this.initialize();
        },
        padraoIcon(item) {
            return item.padrao === 1 ? this.$t('button.confirm') : this.$t('button.dismiss');
        },
        translateThemeName(item) {
            if (!item || !item.descricao) return '';
            // Traduz apenas o tema padrão usando a chave database.themes.mainTheme
            if (item.padrao === 1) {
                return translateDbField('database.themes.mainTheme', item.descricao);
            }
            // Outros temas exibem o nome do banco de dados
            return item.descricao;
        },
    },
}
</script>

<style>
.list-item {
    height: 10vh;
    margin: 2vh 0;
}
</style>